import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Translation } from 'react-i18next';

import { fetchMe } from 'redux/users/actions';
import {
  clearCustomDomainStatus,
  clearCustomDomainDeleteStatus,
} from 'redux/settings/actions';

import AddDomainForm from 'components/dashboard/settings-content/CustomDomain/AddDomainForm';
import CustomDomainDetails from 'components/dashboard/settings-content/CustomDomain/CustomDomainDetails';
import VerifyCustomDomain from 'components/dashboard/settings-content/CustomDomain/VerifyCustomDomain';
import CustomDomainInfo from 'components/dashboard/settings-content/CustomDomain/CustomDomainInfo';
import ProSectionPlaceholder
  from 'components/common/pro-placeholders/ProSectionPlaceholder';


class CustomDomainContent extends Component {
  static propTypes = {
    me: PropTypes.object,
    postCustomDomainSuccess: PropTypes.object,
    deteteCustomDomainSuccess: PropTypes.bool,
    fetchMe: PropTypes.func.isRequired,
    clearCustomDomainStatus: PropTypes.func,
    clearCustomDomainDeleteStatus: PropTypes.func,
  };
  static defaultProps = {
    me: null,
    postCustomDomainSuccess: null,
    deteteCustomDomainSuccess: null,
    clearCustomDomainStatus: null,
    clearCustomDomainDeleteStatus: null,
  };

  componentDidUpdate(prevProps) {
    if (
      !prevProps.postCustomDomainSuccess &&
      prevProps.postCustomDomainSuccess !== this.props.postCustomDomainSuccess
    ) {
      this.props.fetchMe();
      setTimeout(() => {
        this.props.clearCustomDomainStatus();
      }, 500);
    }

    if (
      !prevProps.deteteCustomDomainSuccess &&
      prevProps.deteteCustomDomainSuccess !== this.props.deteteCustomDomainSuccess
    ) {
      this.props.fetchMe();
      setTimeout(() => {
        this.props.clearCustomDomainDeleteStatus();
      }, 500);
    }
  }

  render() {
    const { me } = this.props;

    return (
      <Translation>
        {(t) => (
          <ProSectionPlaceholder
            key="cusom-domain-content-pro-feature-key"
            locked={me && me.subscription && !me.subscription.ff_custom_domain}
            className="cusom-domain-content__component"
            text={
              <>
                {t("You can create custom domain on the PRO plan. Check it")}
              </>
            }
          >
            <div className="cusom-domain-content-wrapper">
              {/* Add Custom Domain */}
              <AddDomainForm />

              {/* Connected Custom Domain */}
              <CustomDomainInfo />

              {/* Custom Domain Details (TXT, CNAME) */}
              <CustomDomainDetails />

              {/* Verify Custom Domain */}
              <VerifyCustomDomain />

            </div>
          </ProSectionPlaceholder>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    postCustomDomainSuccess: state.settingsReducer.postCustomDomainSuccess,
    postCustomDomainError: state.settingsReducer.postCustomDomainError,
    deteteCustomDomainSuccess: state.settingsReducer.deteteCustomDomainSuccess,
    deteteCustomDomainError: state.settingsReducer.deteteCustomDomainError,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchMe,
    clearCustomDomainStatus,
    clearCustomDomainDeleteStatus,
  },
)(CustomDomainContent);
